module.exports = __webpack_public_path__ + "img/gc_country_flag_np.22adb433.svg";